import { Component, OnInit } from '@angular/core';
import {EsBsModalService} from "../../services/bsModalService/bs-modal.service";
import {StoryService} from "../../services/storyService/story.service";

@Component({
  selector: 'app-email-sending-confirm-modal',
  templateUrl: './email-sending-confirm-modal.component.html',
  styleUrls: ['./email-sending-confirm-modal.component.scss']
})
export class EmailSendingConfirmModalComponent implements OnInit {
  public Yiit = Yiit;
  public userEmail = window['PROFILE']['email'];

  constructor(private bsModal: EsBsModalService, private storyAdapter: StoryService) { }

  ngOnInit() {
  }

  confirmMessage(flag){
      this.bsModal.modalEventFire$ = {'confirm': flag};
  }
}
